export const SET_IS_DOCS_UPLOAD = "SET_IS_DOCS_UPLOAD";
export const SET_GET_TO_KNOW_YOU = "SET_GET_TO_KNOW_YOU";
export const GET_INVITED_SIGNATORIES_STARTED =
  "GET_INVITED_SIGNATORIES_STARTED";
export const GET_INVITED_SIGNATORIES_SUCEEDED =
  "GET_INVITED_SIGNATORIES_SUCEEDED";
export const GET_INVITED_SIGNATORIES_FAILED = "GET_INVITED_SIGNATORIES_FAILED";
